export enum Abrechnungsmodelltyp {
    PAUSCHAL = 'PAUSCHAL',
    SPITZ = 'SPITZ',
    SPITZLIGHT = 'SPITZLIGHT'
}

export class AbrechnungsmodelltypItem {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): AbrechnungsmodelltypItem[] {
        return [
            new AbrechnungsmodelltypItem(Abrechnungsmodelltyp.PAUSCHAL, 'Pauschal'),
            new AbrechnungsmodelltypItem(Abrechnungsmodelltyp.SPITZ, 'Spitz'),
            new AbrechnungsmodelltypItem(Abrechnungsmodelltyp.SPITZLIGHT, 'Spitz-Light'),
        ];
    }

}

